// extracted by mini-css-extract-plugin
module.exports = {"root":"CreatorsLevelChangeOverviewTable_root__zpxcI","badgeForName":"CreatorsLevelChangeOverviewTable_badgeForName__jCbV1"};